import { ComponentType } from "react";
import { DiagramDefinition } from "./types";

import { architectureOverviewDefinition as m001 } from "./definitions/m001";
import { m002Definition as m002 } from "./definitions/m002";
import { m003Definition as m003 } from "./definitions/m003";
import { m004Definition as m004 } from "./definitions/m004";
import { m005Definition as m005 } from "./definitions/m005";
import { m006Definition as m006 } from "./definitions/m006";
import { m007Definition as m007 } from "./definitions/m007";
import { m008Definition as m008 } from "./definitions/m008";
import { m009Definition as m009 } from "./definitions/m009";
import { m010Definition as m010 } from "./definitions/m010";
import { m011Definition as m011 } from "./definitions/m011";
import { m012Definition as m012 } from "./definitions/m012";
import { m013Definition as m013 } from "./definitions/m013";
import { m014Definition as m014 } from "./definitions/m014";
import { m015Definition as m015 } from "./definitions/m015";
import { m016Definition as m016 } from "./definitions/m016";
import { m017Definition as m017 } from "./definitions/m017";
import { m018Definition as m018 } from "./definitions/m018";
import { m019Definition as m019 } from "./definitions/m019";
import { m020Definition as m020 } from "./definitions/m020";
import { m021Definition as m021 } from "./definitions/m021";
import { m022Definition as m022 } from "./definitions/m022";
import { m023Definition as m023 } from "./definitions/m023";
import { m024Definition as m024 } from "./definitions/m024";

export interface RegistryItem {
  id: string;
  definition: DiagramDefinition | any;
  lazyImport: () => Promise<{ default: ComponentType<any> }>;
}

export const diagramRegistry: Record<string, RegistryItem> = {
  // 1. Overview
  "introduction.md": {
    id: "M-001",
    definition: m001,
    lazyImport: () => import("./diagrams/ArchitectureOverviewDiagram"),
  },
  "project-structure.md": {
    id: "M-002",
    definition: m002,
    lazyImport: () => import("./diagrams/GenericFlowchartDiagram"),
  },

  // 2. API & Routing
  "routing.md": {
    id: "M-003",
    definition: m003,
    lazyImport: () => import("./diagrams/GenericFlowchartDiagram"),
  },
  "middleware.md": {
    id: "M-004",
    definition: m004,
    lazyImport: () => import("./diagrams/GenericFlowchartDiagram"),
  },
  "validation.md": {
    id: "M-005",
    definition: m005,
    lazyImport: () => import("./diagrams/GenericFlowchartDiagram"),
  },

  // 3. Data & Services
  "database.md": {
    id: "M-006",
    definition: m006,
    lazyImport: () => import("./diagrams/GenericFlowchartDiagram"),
  },

  // 4. Security & Auth
  "authentication.md": {
    id: "M-007",
    definition: m007,
    lazyImport: () => import("./diagrams/GenericFlowchartDiagram"),
  },

  // 5. Hosting & Deployment
  "deployment.md": {
    id: "M-008",
    definition: m008,
    lazyImport: () => import("./diagrams/GenericFlowchartDiagram"),
  },

  // 6. File Storage
  "file-storage-upload.md": {
    id: "M-009",
    definition: m009,
    lazyImport: () => import("./diagrams/GenericFlowchartDiagram"),
  },
  "file-storage-protected-tokens.md": {
    id: "M-010",
    definition: m010,
    lazyImport: () => import("./diagrams/SequenceDiagramView"),
  },
  "file-storage-serve-files.md": {
    id: "M-011",
    definition: m011,
    lazyImport: () => import("./diagrams/GenericFlowchartDiagram"),
  },
  "file-storage-thumbnail-generation.md": {
    id: "M-011",
    definition: m011,
    lazyImport: () => import("./diagrams/GenericFlowchartDiagram"),
  },

  // 7. Realtime
  "realtime-websocket.md": {
    id: "M-012",
    definition: m012,
    lazyImport: () => import("./diagrams/SequenceDiagramView"),
  },
  "realtime-sse.md": {
    id: "M-013",
    definition: m013,
    lazyImport: () => import("./diagrams/GenericFlowchartDiagram"),
  },
  "realtime-subscription-channels.md": {
    id: "M-014",
    definition: m014,
    lazyImport: () => import("./diagrams/StateDiagramView"),
  },

  // 8. Migrations
  "migrations-directory-structure.md": {
    id: "M-015",
    definition: m015,
    lazyImport: () => import("./diagrams/GenericFlowchartDiagram"),
  },
  "migrations-running-migrations.md": {
    id: "M-016",
    definition: m016,
    lazyImport: () => import("./diagrams/GenericFlowchartDiagram"),
  },
  "migrations-rollback.md": {
    id: "M-017",
    definition: m017,
    lazyImport: () => import("./diagrams/GenericFlowchartDiagram"),
  },

  // 9. JavaScript Hooks
  "javascript-hooks-available-hook-events.md": {
    id: "M-018",
    definition: m018,
    lazyImport: () => import("./diagrams/GenericFlowchartDiagram"),
  },
  "javascript-hooks-available-globals.md": {
    id: "M-019",
    definition: m019,
    lazyImport: () => import("./diagrams/GenericFlowchartDiagram"),
  },

  // 10. API Reference
  "api-reference-base-url.md": {
    id: "M-020",
    definition: m020,
    lazyImport: () => import("./diagrams/GenericFlowchartDiagram"),
  },
  "api-reference-other.md": {
    id: "M-021",
    definition: m021,
    lazyImport: () => import("./diagrams/GenericFlowchartDiagram"),
  },

  // 11. SDKs
  "sdk-ai.md": {
    id: "M-022",
    definition: m022,
    lazyImport: () => import("./diagrams/GenericFlowchartDiagram"),
  },
  "sdk-tauri.md": {
    id: "M-023",
    definition: m023,
    lazyImport: () => import("./diagrams/GenericFlowchartDiagram"),
  },
  "sdk-mcp.md": {
    id: "M-024",
    definition: m024,
    lazyImport: () => import("./diagrams/GenericFlowchartDiagram"),
  },
};
